
import {useHead} from '@vueuse/head'
import YieldCheckNewDash from "./yieldchecknew/YieldCheckNewDash.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import {computed, defineComponent, reactive} from "vue";

import VButton from '../components/base/button/VButton.vue'
import {useToggle} from '@vueuse/core'
import {mapState} from "vuex";

export default defineComponent({
  name: 'YieldCheckNew',
  components: {
    VButton,
    YieldCheckNewDash,
    SidebarLayout
  },
  setup() {
    const siteData = reactive({
      title: `Yield Checker New`
    })
    useHead({
      title: computed(() => siteData.title),
    })
    useToggle(false)
  },
  data() {
    return {
      LoggedIn: {
        LoggedIn: localStorage.isLoggedIn
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },

})


